export const serverMap = {
  matchTrackerApi: {
    name: 'Match Tracker API',
    urlKey: 'PUBLIC_MATCH_TRACKER_API_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  staticAssetApi: {
    name: 'Static Asset API',
    urlKey: 'PUBLIC_STATIC_ASSET_API_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  managementApi: {
    name: 'Management API',
    urlKey: 'PUBLIC_MANAGEMENT_API_URL',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  auth: {
    name: 'Auth API',
    urlKey: 'PUBLIC_AUTH_API_URL',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  daemon: {
    name: 'Daemon',
    urlKey: 'PUBLIC_DAEMON_API_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  metricsServer: {
    name: 'Metrics Server',
    urlKey: 'PUBLIC_METRICS_SERVER_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    },
    defaultBroker: 'ws://localhost:15675',
    defaultMQTTBrokerProtocol: 'ws'
  },
  sportscaster: {
    name: 'Sportscaster',
    urlKey: 'PUBLIC_SPORTSCASTER_API_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    },
    defaultBroker: 'ws://localhost:8080'
  },
  streaming: {
    name: 'Streaming',
    urlKey: 'PUBLIC_STREAMING_API_URL',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  broadcastApi: {
    name: 'Broadcast API',
    urlKey: 'PUBLIC_BROADCAST_API_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  },
  reportingApi: {
    name: 'Reporting API',
    urlKey: 'PUBLIC_REPORTING_API_URI',
    endpoints: {
      version: '/api/config/version',
      config: '/api/config/app'
    }
  }
} as const

export type ServerKeys = keyof typeof serverMap

export type ServerMap = typeof serverMap

export interface ServersState {
  serverMap: ServerMap
  urls: {
    [key in ServerKeys]: ServerUrls
  }
  connections: {
    [key in ServerKeys]: {
      connected: boolean
      hasMadeSuccessfulConnection: boolean
    }
  }
  versions: {
    [key in ServerKeys]: string
  }
  configs: {
    [k in ServerKeys]: ServerConfig
  }
}

export type ServerUrls = {
  url: string
  websocketUrl: string
}

export type ServerConfig = {
  Product: string
  Env: string
  Region: string
  FeatureFlags: {
    [key: string]: boolean
  }
  GeniusIntegration?: boolean
}

export type MetricsServerConfig = ServerConfig & {
  Mode: string
  EnableAutoSleepToggle: boolean
  Algorithms: {
    EstimateZ: boolean
    ArchimedesConfig: any
    ForwardPassThreshold: number
    UseV2PassKick: boolean
    SeatSwapping?: {
      Enabled: boolean
    }
  }
  UnitSystems: string[]
  GeniusIntegration: boolean
  AFLWIntegration: {
    Enabled: boolean
  }
  DebugConfig?: {
    ProfileCPU: boolean
    DontKillPipes: boolean
    ActorMetricsEnabled: boolean
    ActorDebugEnabled: boolean
  }
}

export const EMPTY_SERVER_CONFIG: ServerConfig = {
  Product: '',
  Env: '',
  Region: '',
  FeatureFlags: {}
}

export const EMPTY_METRICS_SERVER_CONFIG: MetricsServerConfig = {
  Product: '',
  Env: '',
  Region: '',
  Mode: '',
  FeatureFlags: {},
  EnableAutoSleepToggle: false,
  Algorithms: {
    EstimateZ: false,
    ArchimedesConfig: {},
    ForwardPassThreshold: 0,
    UseV2PassKick: false
  },
  UnitSystems: [],
  GeniusIntegration: false,
  AFLWIntegration: {
    Enabled: false
  }
}

export const EMPTY_SERVER_CONFIG_MAP: ServersState['configs'] = {
  matchTrackerApi: EMPTY_SERVER_CONFIG,
  sportscaster: EMPTY_SERVER_CONFIG,
  staticAssetApi: EMPTY_SERVER_CONFIG,
  auth: EMPTY_SERVER_CONFIG,
  daemon: EMPTY_SERVER_CONFIG,
  managementApi: EMPTY_SERVER_CONFIG,
  metricsServer: EMPTY_METRICS_SERVER_CONFIG,
  streaming: EMPTY_SERVER_CONFIG,
  broadcastApi: EMPTY_SERVER_CONFIG,
  reportingApi: EMPTY_SERVER_CONFIG
}
